'use client'

/**
 * 슬러그 기반 3D 아바타 채팅 페이지 전용 레이아웃
 *
 * 기본 RootLayout의 헤더를 숨기고 전체 화면을 사용합니다.
 * NavigationBar는 페이지 내부에서 별도로 렌더링됩니다.
 *
 * NOTE: /chat/[agentId]/layout.tsx와 동일한 구조
 * - fixed inset-0: 전체 화면 고정 레이아웃
 * - z-50: 다른 요소들 위에 렌더링
 * - ThreeCanvas가 제대로 렌더링되려면 이 레이아웃이 필수!
 */
export default function SlugLayout({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <div className="fixed inset-0 z-50 bg-white">
      {children}
    </div>
  )
}
